// extracted by mini-css-extract-plugin
export default {"wrapper":"TabbedContent_wrapper__WVgXL","card":"TabbedContent_card__aun+y","container":"TabbedContent_container__3SpGL"};